"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { v4 as uuidv4 } from "uuid";

/**
 * PÁGINA INICIAL DO SISTEMA DE CHAT
 * =================================
 * 
 * Esta página funciona como um redirecionador automático.
 * Quando alguém acessa o site na raiz (exemplo.com/), ela:
 * 
 * 1. Gera um ID único para um novo chat
 * 2. Redireciona automaticamente para /chat/[id]
 * 
 * Isso simplifica a experiência do usuário, pois não precisa
 * navegar manualmente para criar um novo chat.
 * 
 * PARA INICIANTES:
 * - useEffect(): executa código quando o componente é montado
 * - useRouter(): hook do Next.js para navegação programática
 * - uuidv4(): gera um identificador único universal
 */
export default function Home() {
  const router = useRouter();

  useEffect(() => {
    // Gera um ID único para o novo chat
    const newChatId = uuidv4();
    
    // Redireciona para a página de chat com o novo ID
    router.push(`/chat/${newChatId}`);
  }, [router]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-white dark:bg-n0">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primaryColor mx-auto mb-4"></div>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Iniciando chat...
        </p>
      </div>
    </div>
  );
}
